import React, { useState, useEffect } from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { find } from 'lodash';
import { PageTitle, Modal } from '../../../../../components';
import * as Styled from '../styles';
import { RULE_MANAGER } from '../enums';

const DeleteRuleModal = ({
  hook,
}: {
  hook: any
}) => (
  <Modal isOpen={hook.isDeleteModalOpen}>
    <Styled.ModalWrapperStyled>
      <Styled.TopStyled>
        <PageTitle>
          {RULE_MANAGER.TITLE}
        </PageTitle>

        <Styled.CloseButtonStyled
          theme="secondary"
          onClick={() => { hook.setIsDeleteModalOpen(false); }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </Styled.CloseButtonStyled>
      </Styled.TopStyled>

      <Styled.ContentStyled>
        {RULE_MANAGER.RULE_DELETE_WARNING}
      </Styled.ContentStyled>
      <Styled.FooterStyled>
        <Styled.ButtonStyled
          theme="secondary"
          onClick={() => { hook.setIsDeleteModalOpen(false); }}
        >
          {RULE_MANAGER.RULE_DELETE_CANCEL}
        </Styled.ButtonStyled>
        <Styled.ButtonStyled
          theme="primary"
          onClick={() => { hook.deletePostback(); }}
        >
          {RULE_MANAGER.RULE_DELETE}
        </Styled.ButtonStyled>
      </Styled.FooterStyled>
    </Styled.ModalWrapperStyled>
  </Modal>
);

export default DeleteRuleModal;
